import { Box, Flex, Text, Menu, MenuButton, Button } from "@chakra-ui/react";
import styled from "styled-components";
import { FaPlus } from "react-icons/fa";
import { MdClass } from "react-icons/md";
import { green700 } from "core/resources/theme/colors";
import useModal from "../../hooks/useModal";

function Header() {

  const { setIsOpen } = useModal();

  return (
    <Flex
      as="header"
      w="100%"
      justifyContent="space-between"
      h="24"
      px="12"
      borderColor="gray.500"
      boxShadow="0px 1px 4px #0000007D"
    >
      <Flex flexDir="row" alignItems="center">
        {/* <Image src={AgrodriveLogo} style={{ width: 50 }} /> */}
        <IconContainer>
          <MdClass size={32} color="#fff" />
        </IconContainer>
        <Text
          fontSize="26px"
          fontWeight="medium"
          letterSpacing="tight"
          justifyContent="center"
          color="#676C77"
          // mt="8"
          ml="2"
        >
          Classes de Operação
        </Text>
      </Flex>

      <Box mt="7">
        <Menu>
          <MenuButton
            as={Button}
            leftIcon={<FaPlus fontSize={12} />}
            fontSize={16}
            fontWeight="medium"
            _hover={{ opacity: 0.73 }}
            px={"8px"}
            bg={green700}
            rounded={20}
            color={"white"}
            _expanded={{ bg: green700 }}
            onClick={() => setIsOpen(true)}
          >
            Nova Classe
          </MenuButton>
        </Menu>
      </Box>
    </Flex>
  );
}

const IconContainer = styled.div`
  background-color: #11A557;
  padding: 8px;
  border-radius: 50%;
`;

export default Header;
